export default __webpack_public_path__ + "fa92bd372c19927bfdf2e6722ca9ca3f.png";